export default "__VITE_ASSET__Suj_dong__"